import React from 'react';

import { notification, Modal } from 'antd/lib';
import { graphql, compose, withApollo } from 'react-apollo';
import Loading from '../../../common/Loading';

import getArticulos from '../../../../graphql/querys/articulos/getArticulos.graphql';
import deleteArticulo from '../../../../graphql/mutations/articulos/deleteArticulo.graphql';

import TablaArticulos from './TablaArticulos';
import { errorService } from '../../../../graphql/utils/utils';

const confirm = Modal.confirm;
@compose(
  graphql(getArticulos, { options: { fetchPolicy: 'network-only' } }),
  graphql(deleteArticulo, {
    name: 'deleteArticulo',
    options: {
      refetchQueries: [{ query: getArticulos }],
    },
  })
)
class VerArticulos extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      filtro: '',
    };

    this.onDelete = this.onDelete.bind(this);
  }

  onDelete(id) {
    //TODO: Hacer el onDelete.

    let yo = this;
    confirm({
      title: 'Realmente quiere eliminar este articulo?',
      content: 'Esta accion no podrá deshacerse',
      onOk() {
        yo.props
          .deleteArticulo({
            variables: { _id: id },
          })
          // eslint-disable-next-line no-unused-vars
          .then(res => {
            notification.success({
              message: 'Articulo eliminado',
              description: 'Se ha eliminado correctamente el articulo',
            });
          })
          .catch(err => {
            console.log('Existio un error a la hora de eliminar el articulo');
            console.log(err);
            errorService(err, {
              _id: id,
            });

            Modal.error({
              title: 'Error en la eliminacion del articulo',
              content:
                'Lamentamos informarle que la operacion que intentó realizar, no se llevo a cabo por un error interno. Si el error persiste, comuniquesé con el departamento de informatica para obtener mas detalles.',
            });
          });
      },
      onCancel() {
        console.log('Cancel');
      },
    });
  }

  render() {
    if (this.state.loading) {
      return <Loading />;
    }

    // console.log(this.props.data);

    let listaArticulos = this.props.data.getArticulos;

    if (!listaArticulos) {
      listaArticulos = [];
    }

    // console.log("PROPS");
    // console.log(this.props);
    // console.log(listaArticulos);

    return (
      <div>
        <TablaArticulos
          articulos={listaArticulos}
          history={this.props.history}
          onDelete={this.onDelete}
        />
      </div>
    );
  }
}

export default withApollo(VerArticulos);
